<template>
    <div class="layouts">
      <navbar></navbar>
      <router-view></router-view>
      <footerbar></footerbar>
      <el-backtop :bottom="100">
        <div
          style="{
            height: 100%;
            width: 100%;
            background-color: #edf1ff;
            box-shadow: 0 0 6px rgb(57 124 236 / 12%);
            text-align: center;
            line-height: 40px;
            color: #3964E6;
            font-size:24px;
          }"
        >
          <i class="el-icon-caret-top"></i>
        </div>
      </el-backtop>
    </div>
</template>
<script>
import Navbar from "@/components/Navbar"
import Footerbar from "@/components/Footerbar"
export default {
    name:'Layout',
    data(){
        return{
        }
    },
    components:{
      Navbar,Footerbar
    },
    mounted(){
     
    },
    methods:{
    
    }
}
</script>
